module.exports = __webpack_public_path__ + "img/France.6e7ddfea.svg";